import { ErrorBase, ErrorWithCause } from '@util/Errors';

export class ContextNotInitializedError extends ErrorBase<string> {
    constructor(error: Pick<ErrorWithCause<string>, 'name'>) {
        super({ name: error.name, message: 'Context not initialized', cause: null });
    }
}
